export const QUANTITY = "QUANTITY";
export const MARKETPRICE = "MARKETPRICE";
export const ORIGINALPRICE = "ORIGINALPRICE";
export const PROFITANDLOSS = "PROFITANDLOSS";
export const TODAYSPROFITANDLOSS = "TODAYSPROFITANDLOSS";
export const MARKETVALUE = "MARKETVALUE";